import React from "react";
import { Card, CardBody } from "reactstrap";
import CptShimmerBlock from "../CptShimmerBlock";

const MprStatCardShimmer = ({ tone = "blue" }) => (
  <Card className={`mpr-stat-card mpr-tone-${tone} mpr-shimmer-shell-card`}>
    <CardBody>
      <div className="mpr-stat-meta mpr-shimmer-stat-meta">
        <CptShimmerBlock className="mpr-shimmer-stat-title-line" />
        <div className="mpr-stat-compare mpr-shimmer-stat-compare-shell" aria-hidden="true">
          <div className="mpr-shimmer-stat-compare-item">
            <CptShimmerBlock className="mpr-shimmer-stat-compare-label" />
            <CptShimmerBlock className="mpr-shimmer-stat-compare-value" />
          </div>
          <div className="mpr-shimmer-stat-compare-item">
            <CptShimmerBlock className="mpr-shimmer-stat-compare-label" />
            <CptShimmerBlock className="mpr-shimmer-stat-compare-value" />
          </div>
        </div>
        <div className="mpr-shimmer-stat-diff-row" aria-hidden="true">
          <CptShimmerBlock className="mpr-shimmer-stat-diff-icon" />
          <CptShimmerBlock className="mpr-shimmer-stat-diff-value" />
        </div>
      </div>
      <CptShimmerBlock className="mpr-shimmer-stat-icon-block" />
    </CardBody>
  </Card>
);

export default MprStatCardShimmer;
